import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.ts";
import {CalListCache, EventStore} from "../server/EventStore.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Html from "../util/Html.ts";
import * as Screen from "../lib/Screen.ts";
import  {Calendar} from "../lib/fullcalendar/all.ts";
import * as libLocation from "../lib/location.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import * as calendar_modal from "../calendar/calendar_modal.ts";
import * as i18n from "../i18n.ts";
import * as Storage from "../lib/Storage.ts";
import * as currentCalendar from "./currentTimetable.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as timetableModal from "./timetableModal.ts";

import TPL_timetableempty from "../timetable/timetable_empty.mustache";
import TPL_timetableswitch from "../timetable/timetableswitch.mustache";
import TPL_modal_timetablecopyslice from "../timetable/modal_timetablecopyslice.mustache";
import TPL_modal_timetablecopyslice_content from "../timetable/modal_timetablecopyslice_content.mustache";
import TPL_modal_timetablecopyweek from "../timetable/modal_timetablecopyweek.mustache";

import Icons from "../svg/Icons.ts";
import { eventDrop, eventModified } from "../calendar/fullcalendar_dragdrop.ts";
import FizConfig from "../FizConfig.ts";

var alltimetable,currenttimetable ;

amplify.subscribe("familyScopeChange sessionExpired",function(){
  alltimetable = currenttimetable = undefined;
})
actionMenu.register({
  timetable(){
    var buttons :actionMenu.ActionMenuButton[] = [{onclick:'timetablepickcreate',svg:Icons.ic_add_plus,i18nkey:'timetable.create'}];
    if(currenttimetable.rights.canUpdate){
      buttons.push({onclick:'timetableedit|'+currenttimetable.metaId,svg:Icons.ic_settings,i18nkey:'timetable.settings'})
    }
    if(currenttimetable.multiWeek || currenttimetable.isOneTime){
      buttons.push({onclick:'timetablecopyslice|'+currenttimetable.metaId,svg:Icons.ic_replay,i18nkey:'timetable.copyweek'})
    }
    buttons.push({onclick:'timetableshare|'+currenttimetable.metaId,svg:Icons.ic_link,i18nkey:'actions.share'})
    buttons.push({onclick:'print',svg:Icons.ic_print,i18nkey:'actions.print'})
    if(currenttimetable.rights.canUpdate){
      if(currenttimetable.isByUrl){
        buttons.push({onclick:'timetabledelete|'+currenttimetable.metaId,svg:Icons.ic_delete,i18nkey:'timetable.delete',color:'var(--red)'})
      }else{
        buttons.push({onclick:'timetableclear|'+currenttimetable.metaId,svg:Icons.ic_delete,i18nkey:'timetable.clear',color:'var(--red)'})
      }
    }

    return {'menu':buttons}
  },
  timetableswitch(){
    var
      currentTimetableId = currenttimetable?.metaId,
      result = [];
    alltimetable.forEach(timetable=>{
      var svgend = timetable.metaId===currentTimetableId?Icons.ic_checkmark:undefined
      result.push({'emoji':timetable.emoji,svg:timetable.emoji?undefined:Icons.calendar.ic_timetable,'title':timetable.name,onclick:'timetableswitch|'+timetable.metaId,svgend})
    });
    result.push({svg:Icons.ic_add_plus,i18nkey:'timetable.create',onclick:'timetablepickcreate'});
    return {menu:result};
  }
})


Html.registerDom({
  async timetableshare(){
    var [bean,TPL] = await Promise.all([
      ApiServer.evtsharedlink(currenttimetable.metaId),
      import("../modal/dialog_share.mustache")
    ]);
    modal.openDomModal(TPL,{title: 'timetable.sharetitle',message:'timetable.sharetext',link:bean.link,pictureUrl:FwDatas.getFamily().coverUri});

  },
  timetablepickcreate(){
    timetableModal.openPickCreateTimetable();
  },
  timetablecreate(type){
    timetableModal.openCreateTimetable(type);
  },
  timetableedit(metaId){
    var calendar = FwDatas.get(metaId);
    timetableModal.openEditTimetable(calendar.timetable || calendar);
  },

  timetableswitch(metaId){
    Storage.localSet('timetable.current',metaId);
    refreshData();
  },
  timetableclear(metaId){
    let timetable =  FwDatas.get(metaId);
    modal.ask({
      title:i18n.get('timetable.cleartitle',timetable),
      message:'timetable.cleartext',
      button:[{
        title:'actions.reset',
        onclick:function(){
          if(timetable.isOneTime){
            var
              date = currentCalendar.get().currentData.viewApi.currentStart,
              range = DateUtils.getWeekRange(date,timetable.calendarFirstDayOfWeek);
            ApiServer.evttimetableResetSliceByDate(timetable.metaId,range.start,range.end)
            amplify.publish("eventDeleted")
          }else{
            ApiServer.evttimetableResetSlice(timetable.metaId,timetable.currentWeekIndex)
            amplify.publish("eventDeleted");
          }
        }
      },{
        title:'actions.delete',
        class:'negative',
        action:'timetabledelete|'+timetable.metaId
      }]
    })

  },
  timetablecopyslice(metaId){
    let timetable =  FwDatas.get(metaId);
    if(timetable.isOneTime){
      var
        date = currentCalendar.get().currentData.viewApi.currentStart,
        range = DateUtils.getWeekRange(new Date(date.getTime()-1000),timetable.calendarFirstDayOfWeek ), //the week before
        days = range.getDays(),
        theModal = modal.openDomModal(TPL_modal_timetablecopyslice,{timetable,range,days,targetStart:range.start})
      async function update(){
        var events = await EventStore.loadEventsBySync([currenttimetable.metaId],[],range)
        days.forEach(day=>{
          day.events = events.filter(event=>event.startDate>=day.start && event.startDate<day.end)
        })
        const formNode = theModal.querySelector('form');
        if(formNode) Html.setHtml(formNode,TPL_modal_timetablecopyslice_content,{timetable,range,days,targetStart:date})

      }
      update();
      theModal.addEventListener('click', Html.createDelegateListener('.timenav .prev', function(){
        range = DateUtils.getWeekRange(range.prev,timetable.calendarFirstDayOfWeek);
        days = range.getDays();
        update();
      }))
      theModal.addEventListener('click', Html.createDelegateListener('.timenav .next', function(){
        range = DateUtils.getWeekRange(range.next,timetable.calendarFirstDayOfWeek);
        days = range.getDays();
        update();
      }))

    }else if(timetable.weeks.length>2){
      modal.openDomModal(TPL_modal_timetablecopyweek,timetable)
    }else{

      ApiServer.evttimetableCopySlice(metaId,(timetable.currentWeekIndex===0?1:0),timetable.currentWeekIndex)
    }
  }


})

INR.onPage(INR.URL.TIMETABLE,function(){
  if(FwDatas.getPermission('timetable')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }
  if(libLocation.getURLParam('metaId')){
    Storage.localSet('timetable.current',libLocation.getURLParam('metaId'))
  }

  INR.subscribe('timetableUpdated',function(fresh){
    modal.closeDomModal();
    if(fresh instanceof ApiServer.types.TimetableBean){
      Storage.localSet('timetable.current',fresh.metaId);
    }
    EventStore.invalidate(metaId=>metaId.startsWith('calendarTimetable/'));
    libLocation.refresh();
  })
  refreshData();
  INR.subscribe("eventCreated eventUpdated eventDeleted",function(){
    EventStore.invalidate(metaId=>metaId.startsWith('calendarTimetable/'));
    currentCalendar.get().refetchEvents();
  });
  INR.subscribe("calendarNeedRender",function(){
    currentCalendar.get().render();
  });
  INR.subscribe("pageUnload",function(){
    if(currenttimetable){
      ApiServer.evttimetableClose(currenttimetable.metaId);
    }
  })
});

async function afterCopySlice(eventsCopied){
  if(eventsCopied.length===0){
    //FIXME maybe alert something here
    modal.toast({
      emoji:"🤔",
      text:"actionresult.nothingcopied"
    })
    return;
  }
  modal.closeDomModal();
  amplify.publish("eventCreated")

  modal.toast({
    svg:Icons.ic_done,
    text:i18n.get('mp.copysuccess'),
    button:[{
      title:'actions.undo',
      onclick:function(){
        ApiServer.metadelete(eventsCopied.map(evt=>evt.metaId),function(){amplify.publish('eventDeleted')})
      }
    }]
  })
}

ApiServer.evttimetableCopySliceByDate = ApiServer.evttimetableCopySliceByDate.prepare(afterCopySlice)
ApiServer.evttimetableCopySliceWResult = ApiServer.evttimetableCopySliceWResult.prepare(afterCopySlice)

async function timetableExpiredAlert(timetable){
  if(await modal.simple({
    title:"timetable.outdated.title",
    message:"timetable.outdated.message",
    lottie:"images/lottie/anim_clock.json",
    button:"actions.gotosettings"
  })){
    timetableModal.openEditTimetable(timetable);
  }
}
function timetableExpiredToast(timetable){
  modal.toast({
    text:"timetable.outdated.toast",
    button:[{
      title:"actions.learnmore",
      onclick(){
        timetableExpiredAlert(timetable);
      }
    }]
  })

}

function setCurrentTimeTable(timetable){
  Storage.localSet('timetable.current',timetable.metaId);
  if(timetable.finishDate<new Date()){
    timetableExpiredToast(timetable)
  }
  var usedView = currentCalendar.getView(timetable);

  currenttimetable = timetable;

  var
    weeks = currenttimetable.isOneTime?[]:currenttimetable.weeks,
    fullRange = currenttimetable.isOneTime?null:{
      start:weeks[0].start,
      end:weeks[weeks.length-1].end
    },
    delta = 7*weeks.length;

  currentCalendar.set(new Calendar(document.getElementById("fullcalendar"),{
    initialView:usedView,
    locale: i18n.getSelectedLanguage(),
    allDaySlot:currenttimetable.isOneTime,
    firstDay:currenttimetable.calendarFirstDayOfWeek%7,
    initialDate: currenttimetable.currentDate,
    //validRange: range,
    weekends:currenttimetable.showWeekends,
    scrollTime:'08:00:00',
    height:"parent",
    editable: true,
    //buttonText:i18n.get('eventCalendarNav'),
    headerToolbar: false,
    eventDisplay:'block',
    dayHeaderFormat:currenttimetable.isOneTime?undefined:{ weekday: Screen.isMobileView()?'short':'long' },
    views: {
      dayGridMonth: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', omitZeroMinute: true, meridiem: 'short' }
      },
      week: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: 'short' }
      },
      day: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: 'short' }
      }
    },

    events: function(range, successCallback,failureCallback){
      EventStore.loadEventsBySync([currenttimetable.metaId],[],fullRange||range).then(events=>{
        let
          rawSuggestions = events.sort((a,b)=>b.text.localeCompare(a.text));

        currenttimetable.suggestions = rawSuggestions.filter((evt,idx)=>{
          if(idx===0) return true;
          return evt.text.localeCompare(rawSuggestions[idx-1].text)!==0;
        })
        successCallback(events.map(function(ev){
          var
            result = {
              start:ev.start,
              end:ev.allDay?new Date(new Date(ev.end).getTime()+1000) :ev.end,
              title:ev.title+'\r\n'+(ev.description?ev.description+'\r\n':''),
              classNames:"fw-pre-line",
              description:ev.description,
              color:ev.colorDB  || ev.calendar.color || FizConfig.defaultColor,
              id:ev.metaId,
              allDay:ev.allDay,
              editable:ev.editable
            },
            instancebefore = Object.assign({},result);

          //code after is not applicable
          if(currenttimetable.isOneTime) return [result]

          //in case the event is on last week and first, we need the previous instance for display
          instancebefore.start = new Date(instancebefore.start);
          instancebefore.end = new Date(instancebefore.end);
          instancebefore.start.setDate(instancebefore.start.getDate()-delta);
          instancebefore.end.setDate(instancebefore.end.getDate()-delta);

          return [result,instancebefore]
        }).flat());

      },failureCallback);
    },
    datesSet:function(info){
      currentCalendar.updateViewSelector(currenttimetable,info)
    },
    selectable:!currenttimetable.isByUrl,
    select:function(selectionInfo ){
	  if(currenttimetable.isByUrl) return;
      if(currenttimetable.finishDate<new Date()){
        timetableExpiredAlert(currenttimetable)
        return;
      }
      var
        start = new Date(selectionInfo.start),
        end = new Date(selectionInfo.end);
      if(selectionInfo.allDay){
        end.setDate(end.getDate()-1);
        start.setHours(9);
        end.setHours(10);
      }
      calendar_modal.createEvent(start,end,selectionInfo.allDay,currenttimetable.calendar);
    },
    eventClick: function(obj){
      var
        id = obj.event.id,
        evtFw = FwDatas.get(id);
      if(evtFw){
        calendar_modal.viewEventDetails(evtFw,true)
      }else{
        ApiServer.webjslog("Fullcalendar click : cannot find "+id+" in cache");
      }

    },
    eventResize: eventModified,
    eventDrop
  }),currenttimetable);
  Html.setHtml(document.getElementById('timetableswitch'),TPL_timetableswitch,{current:currenttimetable,timetable:alltimetable});
  currentCalendar.get().render();

}


async function refreshData(){
  modal.closeDomModal();
  var calendarGroupBean = await CalListCache.refresh()
  alltimetable = calendarGroupBean.timetables.map(t=>t.timetable);
  if(alltimetable.length===0){
    Html.setHtml(document.querySelector('.fw-maintable'),TPL_timetableempty,{})
  }else{
    setCurrentTimeTable(alltimetable.filter(t=>t.metaId===Storage.localGet('timetable.current'))[0]||alltimetable[0]);
  }
}


